(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-accessories"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
    const moneyFormat = window.money_format || window.theme?.moneyFormat || "{{ shop.money_format }}";

    function formatMoney(cents) {
      if (typeof Shopify !== "undefined" && typeof Shopify.formatMoney === "function") {
        return Shopify.formatMoney(cents, moneyFormat);
      }

      return (Number(cents || 0) / 100).toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }

    function normalizeText(text) {
      return String(text || "")
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "");
    }

    function isSizeOptionName(optionName) {
      const normalized = normalizeText(optionName);

      return (
        normalized.includes("tamanho") ||
        normalized.includes("size") ||
        normalized.includes("numero") ||
        normalized.includes("numeração") ||
        normalized.includes("numeracao")
      );
    }

    function normalizeDiscountPercent(value) {
      const discount = Number(value || 0);

      if (Number.isNaN(discount)) return 0;
      if (discount < 0) return 0;
      if (discount > 100) return 100;

      return discount;
    }

    function applyDiscount(price, discountPercent) {
      const normalizedPrice = Number(price || 0);
      const normalizedDiscount = normalizeDiscountPercent(discountPercent);

      if (normalizedDiscount <= 0) return normalizedPrice;

      return Math.round(normalizedPrice * ((100 - normalizedDiscount) / 100));
    }

    function replaceElementHTML(selector, html) {
      const currentElement = document.querySelector(selector);

      if (!currentElement || !html) return false;

      const newDocument = new DOMParser().parseFromString(html, "text/html");
      const newElement = newDocument.querySelector(selector);

      if (!newElement) return false;

      currentElement.innerHTML = newElement.innerHTML;

      return true;
    }

    function fetchAndReplaceSection(sectionId, selectors) {
      const cartUrl = window.Shopify.routes.root + "cart";

      return fetch(cartUrl + "?section_id=" + sectionId, {
        method: "GET",
        headers: {
          Accept: "text/html",
        },
      })
        .then(function (response) {
          if (!response.ok) return false;
          return response.text();
        })
        .then(function (html) {
          if (!html) return false;

          let replaced = false;

          selectors.forEach(function (selector) {
            if (replaceElementHTML(selector, html)) {
              replaced = true;
            }
          });

          return replaced;
        })
        .catch(function () {
          return false;
        });
    }

    function refreshCartDrawerHTML() {
      const drawerSelectors = [
        "cart-drawer",
        "#CartDrawer",
        ".cart-drawer",
        "[data-cart-drawer]",
        ".halo-cart-sidebar",
        "#halo-cart-sidebar",
        ".halo-sidebar-cart",
        "#halo-sidebar-cart",
      ];

      const sectionIds = [
        "cart-drawer",
        "halo-cart-sidebar",
        "cart-sidebar",
        "main-cart-items",
      ];

      return sectionIds.reduce(function (promise, sectionId) {
        return promise.then(function (alreadyUpdated) {
          if (alreadyUpdated) return true;
          return fetchAndReplaceSection(sectionId, drawerSelectors);
        });
      }, Promise.resolve(false));
    }

    function refreshCartIconBubble() {
      const bubbleSelectors = [
        "#cart-icon-bubble",
        ".cart-count-bubble",
        "[data-cart-count-bubble]",
        "[data-cart-count]",
        ".cart-count",
        ".header__cart-count",
      ];

      const sectionIds = [
        "cart-icon-bubble",
        "header",
        "main-header",
      ];

      return sectionIds.reduce(function (promise, sectionId) {
        return promise.then(function (alreadyUpdated) {
          if (alreadyUpdated) return true;
          return fetchAndReplaceSection(sectionId, bubbleSelectors);
        });
      }, Promise.resolve(false));
    }

    function openCartDrawer() {
      document.dispatchEvent(new CustomEvent("cart:refresh"));
      document.dispatchEvent(new CustomEvent("cart:open"));
      document.dispatchEvent(new CustomEvent("cart:drawer:open"));
      document.dispatchEvent(new CustomEvent("drawer:open"));
      document.dispatchEvent(new CustomEvent("theme:cart:open"));
      document.dispatchEvent(new CustomEvent("cart-drawer:open"));

      const cartDrawer =
        document.querySelector("cart-drawer") ||
        document.querySelector("cart-notification") ||
        document.querySelector(".cart-drawer") ||
        document.querySelector("#CartDrawer") ||
        document.querySelector("[data-cart-drawer]") ||
        document.querySelector(".halo-cart-sidebar") ||
        document.querySelector("#halo-cart-sidebar") ||
        document.querySelector(".halo-sidebar-cart") ||
        document.querySelector("#halo-sidebar-cart");

      if (cartDrawer) {
        if (typeof cartDrawer.open === "function") {
          cartDrawer.open();
          return;
        }

        cartDrawer.classList.add("active", "is-open", "open", "animate", "show");
        cartDrawer.setAttribute("open", "");
        cartDrawer.setAttribute("aria-hidden", "false");
      }

      const cartDrawerTrigger =
        document.querySelector("[data-cart-sidebar]") ||
        document.querySelector("[data-cart-drawer-toggle]") ||
        document.querySelector("[data-cart-drawer-open]") ||
        document.querySelector('[aria-controls="CartDrawer"]') ||
        document.querySelector('[aria-controls="halo-cart-sidebar"]') ||
        document.querySelector('[aria-controls="halo-sidebar-cart"]') ||
        document.querySelector('a[href="/cart"]') ||
        document.querySelector('a[href*="/cart"]');

      if (cartDrawerTrigger) {
        cartDrawerTrigger.click();
      }
    }

    function refreshCartAndOpenDrawer() {
      fetch(window.Shopify.routes.root + "cart.js", {
        method: "GET",
        headers: {
          Accept: "application/json",
        },
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (typeof window.updateCart === "function") {
            window.updateCart(cart);
          }

          document.dispatchEvent(
            new CustomEvent("cart:updated", {
              detail: {
                cart: cart,
              },
            })
          );

          document.dispatchEvent(
            new CustomEvent("cart:change", {
              detail: {
                cart: cart,
              },
            })
          );

          return Promise.all([
            refreshCartDrawerHTML(),
            refreshCartIconBubble(),
          ]);
        })
        .then(function () {
          setTimeout(openCartDrawer, 150);
        })
        .catch(function (error) {
          console.error("Erro ao atualizar o carrinho lateral:", error);
          setTimeout(openCartDrawer, 150);
        });
    }

    function initProductAccessories(accessoriesBlock) {
      const wrapper = accessoriesBlock.querySelector(".product-accessories-wrapper");
      const addButton = accessoriesBlock.querySelector(".add-accessories-to-cart-button");

      let isDraggingScroll = false;
      let hasDraggedScroll = false;
      let dragStartX = 0;
      let dragScrollLeft = 0;

      function initDragScroll() {
        if (!wrapper) return;

        wrapper.addEventListener("mousedown", function (event) {
          isDraggingScroll = true;
          hasDraggedScroll = false;
          dragStartX = event.pageX - wrapper.offsetLeft;
          dragScrollLeft = wrapper.scrollLeft;

          wrapper.classList.add("is-dragging");
        });

        wrapper.addEventListener("mouseleave", function () {
          isDraggingScroll = false;
          wrapper.classList.remove("is-dragging");
        });

        wrapper.addEventListener("mouseup", function () {
          isDraggingScroll = false;
          wrapper.classList.remove("is-dragging");
        });

        wrapper.addEventListener("mousemove", function (event) {
          if (!isDraggingScroll) return;

          event.preventDefault();

          const x = event.pageX - wrapper.offsetLeft;
          const walk = x - dragStartX;

          if (Math.abs(walk) > 5) {
            hasDraggedScroll = true;
          }

          wrapper.scrollLeft = dragScrollLeft - walk;
        });

        wrapper.addEventListener(
          "click",
          function (event) {
            if (!hasDraggedScroll) return;

            event.preventDefault();
            event.stopPropagation();

            hasDraggedScroll = false;
          },
          true
        );
      }

      const dataScript = accessoriesBlock.nextElementSibling?.matches?.("script[type='application/json']")
        ? accessoriesBlock.nextElementSibling
        : document.querySelector("script[id^='ProductAccessoriesData-']");

      if (!wrapper || !addButton || !dataScript) return;

      let accessoriesData = null;

      try {
        accessoriesData = JSON.parse(dataScript.textContent);
      } catch (error) {
        console.error("Erro ao ler dados do compre junto:", error);
        return;
      }

      const bundleDiscountPercent = normalizeDiscountPercent(
        accessoriesData.bundleDiscountPercent || accessoriesBlock.dataset.bundleDiscountPercent || addButton.dataset.bundleDiscountPercent
      );

      const productItems = Array.from(wrapper.querySelectorAll(".product-bundle-card"));
      const mainItem = wrapper.querySelector(".product-bundle-card.is-main-product");

      function getMainVariantId() {
        const variantInputs = Array.from(
          document.querySelectorAll(
            'form[action*="/cart/add"] input[name="id"], product-form input[name="id"], input[name="id"]'
          )
        );

        const mainVariantInput = variantInputs.find(function (input) {
          return !input.closest(".product-accessories");
        });

        if (mainVariantInput && mainVariantInput.value) {
          return mainVariantInput.value;
        }

        return addButton.dataset.mainVariantId;
      }

      function getMainVariant() {
        const mainVariantId = String(getMainVariantId());

        return accessoriesData.mainProduct.variants.find(function (variant) {
          return String(variant.id) === mainVariantId;
        });
      }

      function getMainSelectedSize() {
        const mainVariant = getMainVariant();

        if (!mainVariant) return null;

        const mainOptions = accessoriesData.mainProduct.options || [];

        let sizeOptionIndex = mainOptions.findIndex(function (optionName) {
          return isSizeOptionName(optionName);
        });

        if (sizeOptionIndex === -1 && mainOptions.length === 1) {
          sizeOptionIndex = 0;
        }

        if (sizeOptionIndex === -1) return null;

        return mainVariant.options[sizeOptionIndex];
      }

      function getAccessoryProductByItem(productItem) {
        const accessoryIndex = productItem.dataset.accessoryIndex;

        if (accessoryIndex === undefined) return null;

        return accessoriesData.accessories[Number(accessoryIndex)] || null;
      }

      function findAccessoryVariantByMainSize(productItem) {
        const selectedSize = getMainSelectedSize();
        const accessoryProduct = getAccessoryProductByItem(productItem);

        if (!accessoryProduct || !accessoryProduct.variants || !accessoryProduct.variants.length) {
          return null;
        }

        if (!selectedSize) {
          const fallbackVariantId = productItem.dataset.productVariantId;

          return (
            accessoryProduct.variants.find(function (variant) {
              return String(variant.id) === String(fallbackVariantId);
            }) ||
            accessoryProduct.variants.find(function (variant) {
              return variant.available;
            }) ||
            accessoryProduct.variants[0]
          );
        }

        const selectedSizeNormalized = normalizeText(selectedSize);
        const accessoryOptions = accessoryProduct.options || [];

        let accessorySizeOptionIndex = accessoryOptions.findIndex(function (optionName) {
          return isSizeOptionName(optionName);
        });

        if (accessorySizeOptionIndex === -1 && accessoryOptions.length === 1) {
          accessorySizeOptionIndex = 0;
        }

        let matchedVariant = null;

        if (accessorySizeOptionIndex !== -1) {
          matchedVariant = accessoryProduct.variants.find(function (variant) {
            return (
              variant.available &&
              normalizeText(variant.options[accessorySizeOptionIndex]) === selectedSizeNormalized
            );
          });

          if (!matchedVariant) {
            matchedVariant = accessoryProduct.variants.find(function (variant) {
              return normalizeText(variant.options[accessorySizeOptionIndex]) === selectedSizeNormalized;
            });
          }
        }

        if (!matchedVariant) {
          matchedVariant = accessoryProduct.variants.find(function (variant) {
            return (
              variant.available &&
              variant.options.some(function (optionValue) {
                return normalizeText(optionValue) === selectedSizeNormalized;
              })
            );
          });
        }

        if (!matchedVariant) {
          matchedVariant = accessoryProduct.variants.find(function (variant) {
            return variant.available;
          });
        }

        return matchedVariant || accessoryProduct.variants[0];
      }

      function updateCardPrice(productItem, variant) {
        if (!variant) return;

        const originalPrice = Number(variant.price || 0);
        const discountedPrice = applyDiscount(originalPrice, bundleDiscountPercent);

        const priceElement = productItem.querySelector("[data-bundle-card-price]");
        const compareElement = productItem.querySelector("[data-bundle-card-compare-price]");

        productItem.dataset.productVariantId = variant.id;
        productItem.dataset.originalPrice = originalPrice;
        productItem.dataset.price = discountedPrice;
        productItem.dataset.compareAtPrice = originalPrice;

        if (priceElement) {
          priceElement.textContent = formatMoney(discountedPrice);
        }

        if (compareElement) {
          compareElement.textContent = formatMoney(originalPrice);

          if (bundleDiscountPercent > 0 && originalPrice > discountedPrice) {
            compareElement.classList.remove("hidden");
          } else {
            compareElement.classList.add("hidden");
          }
        }
      }

      function getItemQuantity(productItem) {
        const input = productItem.querySelector("[data-bundle-qty-input]");
        const min = Number(input?.getAttribute("min") || 0);
        const value = Number(input?.value || 0);

        if (Number.isNaN(value)) return min;

        return Math.max(min, value);
      }

      function setItemQuantity(productItem, quantity) {
        const input = productItem.querySelector("[data-bundle-qty-input]");
        const minusButton = productItem.querySelector("[data-bundle-minus]");
        const min = Number(input?.getAttribute("min") || 0);
        const normalizedQuantity = Math.max(min, Number(quantity || 0));

        if (input) {
          input.value = normalizedQuantity;
        }

        productItem.dataset.quantity = normalizedQuantity;
        productItem.dataset.checked = normalizedQuantity > 0 ? "true" : "false";

        if (!productItem.classList.contains("is-main-product")) {
          productItem.classList.toggle("is-unselected", normalizedQuantity <= 0);
        }

        if (minusButton) {
          minusButton.disabled = normalizedQuantity <= min;
        }
      }

      function updateMainCardVariant() {
        const mainVariant = getMainVariant();

        if (!mainItem || !mainVariant) return;

        updateCardPrice(mainItem, mainVariant);
        addButton.dataset.mainVariantId = mainVariant.id;
      }

      function updateAccessoryCardsVariants() {
        productItems.forEach(function (productItem) {
          if (productItem.classList.contains("is-main-product")) return;

          const accessoryVariant = findAccessoryVariantByMainSize(productItem);

          if (accessoryVariant) {
            updateCardPrice(productItem, accessoryVariant);
          }
        });
      }

      function updateTotals() {
        updateMainCardVariant();
        updateAccessoryCardsVariants();

        let totalPrice = 0;
        let totalComparePrice = 0;

        productItems.forEach(function (productItem) {
          const quantity = getItemQuantity(productItem);

          setItemQuantity(productItem, quantity);

          if (quantity <= 0) return;

          const price = Number(productItem.dataset.price || 0);
          const comparePrice = Number(productItem.dataset.compareAtPrice || price);

          totalPrice += price * quantity;
          totalComparePrice += comparePrice * quantity;
        });

        const totalElement = accessoriesBlock.querySelector("[data-bundle-total]");
        const totalCompareElement = accessoriesBlock.querySelector("[data-bundle-total-compare]");
        const installmentsElement = accessoriesBlock.querySelector("[data-bundle-installments]");
        const discountElement = accessoriesBlock.querySelector("[data-bundle-discount]");

        if (totalElement) {
          totalElement.textContent = formatMoney(totalPrice);
        }

        if (totalCompareElement) {
          totalCompareElement.textContent = formatMoney(totalComparePrice);

          if (bundleDiscountPercent > 0 && totalComparePrice > totalPrice) {
            totalCompareElement.classList.remove("hidden");
          } else {
            totalCompareElement.classList.add("hidden");
          }
        }

        if (installmentsElement) {
          installmentsElement.textContent = "até 10x de " + formatMoney(Math.round(totalPrice / 10));
        }

        if (discountElement) {
          if (bundleDiscountPercent > 0) {
            discountElement.textContent = bundleDiscountPercent + "% OFF";
            discountElement.classList.remove("hidden");
          } else {
            discountElement.classList.add("hidden");
          }
        }
      }

      wrapper.addEventListener("click", function (event) {
        const minusButton = event.target.closest("[data-bundle-minus]");
        const plusButton = event.target.closest("[data-bundle-plus]");

        if (!minusButton && !plusButton) return;

        const productItem = event.target.closest(".product-bundle-card");

        if (!productItem) return;

        const currentQuantity = getItemQuantity(productItem);

        if (minusButton) {
          setItemQuantity(productItem, currentQuantity - 1);
        }

        if (plusButton) {
          setItemQuantity(productItem, currentQuantity + 1);
        }

        updateTotals();
      });

      wrapper.addEventListener("change", function (event) {
        const input = event.target.closest("[data-bundle-qty-input]");

        if (!input) return;

        const productItem = input.closest(".product-bundle-card");

        if (!productItem) return;

        setItemQuantity(productItem, input.value);
        updateTotals();
      });

      document.addEventListener("change", function (event) {
        if (
          event.target.matches('select[name="id"]') ||
          event.target.matches('input[name="id"]') ||
          event.target.closest("[data-product-option-change]") ||
          event.target.closest(".product-form__input") ||
          event.target.closest(".productView-variants")
        ) {
          setTimeout(updateTotals, 100);
        }
      });

      document.addEventListener("click", function (event) {
        if (
          event.target.closest("[data-product-option-change]") ||
          event.target.closest(".product-form__input") ||
          event.target.closest(".productView-variants")
        ) {
          setTimeout(updateTotals, 150);
        }
      });

      addButton.addEventListener("click", function () {
        updateTotals();

        const items = [];

        productItems.forEach(function (productItem) {
          const quantity = getItemQuantity(productItem);

          if (quantity <= 0) return;

          const variantId = productItem.dataset.productVariantId;

          if (!variantId) return;

          items.push({
            id: Number(variantId),
            quantity: quantity,
            properties: {
              "_compre_junto": "true",
              "_desconto_compre_junto": bundleDiscountPercent + "%"
            }
          });
        });

        if (!items.length) return;

        addButton.disabled = true;
        addButton.classList.add("loading");

        fetch(window.Shopify.routes.root + "cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify({
            items: items,
          }),
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (error) {
                throw error;
              });
            }

            return response.json();
          })
          .then(function () {
            refreshCartAndOpenDrawer();
          })
          .catch(function (error) {
            console.error("Erro ao adicionar compre junto:", error);
          })
          .finally(function () {
            addButton.disabled = false;
            addButton.classList.remove("loading");
          });
      });

      initDragScroll();

      productItems.forEach(function (productItem) {
        setItemQuantity(productItem, getItemQuantity(productItem));
      });

      updateTotals();
    }

    document.querySelectorAll("[data-product-accessories]").forEach(initProductAccessories);
  });
  } catch(e) { console.error(e); }
})();

})();
